const formatOpeningTime = (date) => {
    if (!date) {
        return null;
    }
    const time = new Date(date).toLocaleTimeString();
    return time.split(':').slice(0, 2).join(':');
}
export default formatOpeningTime